module.exports = __webpack_public_path__ + "img/1_021.d5539cf7.jpg";